export enum ConfirmationResult{
    confirm =  'confirm',
    reject='reject',
    cancel='cancel'
}